import { render, staticRenderFns } from "./dnc-report.vue?vue&type=template&id=0ef347b1&scoped=true"
import script from "./dnc-report.vue?vue&type=script&lang=ts"
export * from "./dnc-report.vue?vue&type=script&lang=ts"
import style0 from "./dnc-report.vue?vue&type=style&index=0&id=0ef347b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef347b1",
  null
  
)

export default component.exports